// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file auditlog_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AuditlogEventType } from "./auditlog_event_type_pb";
import { file_auditlog_event_type } from "./auditlog_event_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auditlog_service.proto.
 */
export const file_auditlog_service: GenFile = /*@__PURE__*/
  fileDesc("ChZhdWRpdGxvZ19zZXJ2aWNlLnByb3RvEgZkb21haW4i0QEKEldyaXRlRXZlbnRzUmVxdWVzdBIwCgZldmVudHMYASADKAsyIC5kb21haW4uV3JpdGVFdmVudHNSZXF1ZXN0LkV2ZW50GogBCgVFdmVudBISCgpldmVudF9qc29uGAEgASgJEi8KC2NsaWVudF90aW1lGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI6ChZsYXN0X2tub3duX3NlcnZlcl90aW1lGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIoChNXcml0ZUV2ZW50c1Jlc3BvbnNlEhEKCWV2ZW50X2lkcxgBIAMoCSK0BAoRTGlzdEV2ZW50c1JlcXVlc3QSLwoLdGltZV9hbmNob3IYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEgwKBHBhZ2UYAiABKAUSLQoJZnJvbV90aW1lGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIrCgd0b190aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgtldmVudF90eXBlcxgFIAMoDjIZLmRvbWFpbi5BdWRpdGxvZ0V2ZW50VHlwZRIaChJmaWx0ZXJfcHJvZmlsZV9pZHMYBiADKAkSIQoZZmlsdGVyX3RhcmdldF9wcm9maWxlX2lkcxgLIAMoCRIYChBmaWx0ZXJfdmF1bHRfaWRzGAcgAygJEhgKEGZpbHRlcl9sb2dpbl9pZHMYCCADKAkSGAoQZmlsdGVyX2lwX3ByZWZpeBgKIAEoCRJDChFhZGRpdGlvbmFsX2ZpbHRlchgJIAEoCzIoLmRvbWFpbi5MaXN0RXZlbnRzUmVxdWVzdC5NYXRjaEFueUZpbHRlchqBAQoOTWF0Y2hBbnlGaWx0ZXISEwoLcHJvZmlsZV9pZHMYASADKAkSGgoSdGFyZ2V0X3Byb2ZpbGVfaWRzGAUgAygJEhEKCXZhdWx0X2lkcxgCIAMoCRIRCglsb2dpbl9pZHMYAyADKAkSGAoQZmlsdGVyX2lwX3ByZWZpeBgEIAEoCSJ4ChJMaXN0RXZlbnRzUmVzcG9uc2USHAoUZW52ZWxvcGVkX2V2ZW50X2pzb24YASADKAkSEwoLdG90YWxfY291bnQYAiABKAMSLwoLdGltZV9hbmNob3IYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wMqIBCg9BdWRpdGxvZ1NlcnZpY2USSAoLV3JpdGVFdmVudHMSGi5kb21haW4uV3JpdGVFdmVudHNSZXF1ZXN0GhsuZG9tYWluLldyaXRlRXZlbnRzUmVzcG9uc2UiABJFCgpMaXN0RXZlbnRzEhkuZG9tYWluLkxpc3RFdmVudHNSZXF1ZXN0GhouZG9tYWluLkxpc3RFdmVudHNSZXNwb25zZSIAQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw", [file_google_protobuf_timestamp, file_auditlog_event_type]);

/**
 * @generated from message domain.WriteEventsRequest
 */
export type WriteEventsRequest = Message<"domain.WriteEventsRequest"> & {
  /**
   * @generated from field: repeated domain.WriteEventsRequest.Event events = 1;
   */
  events: WriteEventsRequest_Event[];
};

/**
 * Describes the message domain.WriteEventsRequest.
 * Use `create(WriteEventsRequestSchema)` to create a new message.
 */
export const WriteEventsRequestSchema: GenMessage<WriteEventsRequest> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 0);

/**
 * @generated from message domain.WriteEventsRequest.Event
 */
export type WriteEventsRequest_Event = Message<"domain.WriteEventsRequest.Event"> & {
  /**
   * organization id is implicit by auth token
   *
   * @generated from field: string event_json = 1;
   */
  eventJson: string;

  /**
   * time when the event was captured, used to determine principal event timestamp
   *
   * @generated from field: google.protobuf.Timestamp client_time = 2;
   */
  clientTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_known_server_time = 3;
   */
  lastKnownServerTime?: Timestamp | undefined;
};

/**
 * Describes the message domain.WriteEventsRequest.Event.
 * Use `create(WriteEventsRequest_EventSchema)` to create a new message.
 */
export const WriteEventsRequest_EventSchema: GenMessage<WriteEventsRequest_Event> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 0, 0);

/**
 * @generated from message domain.WriteEventsResponse
 */
export type WriteEventsResponse = Message<"domain.WriteEventsResponse"> & {
  /**
   * @generated from field: repeated string event_ids = 1;
   */
  eventIds: string[];
};

/**
 * Describes the message domain.WriteEventsResponse.
 * Use `create(WriteEventsResponseSchema)` to create a new message.
 */
export const WriteEventsResponseSchema: GenMessage<WriteEventsResponse> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 1);

/**
 * organization id is implicit by auth token
 *
 * @generated from message domain.ListEventsRequest
 */
export type ListEventsRequest = Message<"domain.ListEventsRequest"> & {
  /**
   * only show events created at latest at this time for a consistent view
   * omit on initial request
   *
   * @generated from field: google.protobuf.Timestamp time_anchor = 1;
   */
  timeAnchor?: Timestamp | undefined;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * filter between these timestamps
   *
   * @generated from field: google.protobuf.Timestamp from_time = 3;
   */
  fromTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to_time = 4;
   */
  toTime?: Timestamp | undefined;

  /**
   * for each non-empty filter_*,
   * filter events to have one of the listed values
   *
   * @generated from field: repeated domain.AuditlogEventType event_types = 5;
   */
  eventTypes: AuditlogEventType[];

  /**
   * @generated from field: repeated string filter_profile_ids = 6;
   */
  filterProfileIds: string[];

  /**
   * @generated from field: repeated string filter_target_profile_ids = 11;
   */
  filterTargetProfileIds: string[];

  /**
   * @generated from field: repeated string filter_vault_ids = 7;
   */
  filterVaultIds: string[];

  /**
   * @generated from field: repeated string filter_login_ids = 8;
   */
  filterLoginIds: string[];

  /**
   * @generated from field: string filter_ip_prefix = 10;
   */
  filterIpPrefix: string;

  /**
   * If set, filter events accordingly
   *
   * @generated from field: domain.ListEventsRequest.MatchAnyFilter additional_filter = 9;
   */
  additionalFilter?: ListEventsRequest_MatchAnyFilter | undefined;
};

/**
 * Describes the message domain.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 2);

/**
 * @generated from message domain.ListEventsRequest.MatchAnyFilter
 */
export type ListEventsRequest_MatchAnyFilter = Message<"domain.ListEventsRequest.MatchAnyFilter"> & {
  /**
   * Keep all events matching any of the ids below
   *
   * @generated from field: repeated string profile_ids = 1;
   */
  profileIds: string[];

  /**
   * @generated from field: repeated string target_profile_ids = 5;
   */
  targetProfileIds: string[];

  /**
   * @generated from field: repeated string vault_ids = 2;
   */
  vaultIds: string[];

  /**
   * @generated from field: repeated string login_ids = 3;
   */
  loginIds: string[];

  /**
   * @generated from field: string filter_ip_prefix = 4;
   */
  filterIpPrefix: string;
};

/**
 * Describes the message domain.ListEventsRequest.MatchAnyFilter.
 * Use `create(ListEventsRequest_MatchAnyFilterSchema)` to create a new message.
 */
export const ListEventsRequest_MatchAnyFilterSchema: GenMessage<ListEventsRequest_MatchAnyFilter> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 2, 0);

/**
 * @generated from message domain.ListEventsResponse
 */
export type ListEventsResponse = Message<"domain.ListEventsResponse"> & {
  /**
   * @generated from field: repeated string enveloped_event_json = 1;
   */
  envelopedEventJson: string[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * Time anchor to use in request for the following pages
   *
   * @generated from field: google.protobuf.Timestamp time_anchor = 3;
   */
  timeAnchor?: Timestamp | undefined;
};

/**
 * Describes the message domain.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse> = /*@__PURE__*/
  messageDesc(file_auditlog_service, 3);

/**
 * AuditlogService provides methods for handling user accounts.
 *
 * @generated from service domain.AuditlogService
 */
export const AuditlogService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - AuditlogMalformedEvent (90500)
   * - Internal (10500)
   *
   * @generated from rpc domain.AuditlogService.WriteEvents
   */
  writeEvents: {
    methodKind: "unary";
    input: typeof WriteEventsRequestSchema;
    output: typeof WriteEventsResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.AuditlogService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof ListEventsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_auditlog_service, 0);

